import React from 'react';

const ListItemTag = ({ id, fontColor, backgroundColor, label, className }) => {
  return (
    <div id={id} className={className} style={{ color: fontColor, background: backgroundColor }} data-testid="list-item-tag">
      <div className="listItem-tag-content" style={{ backgroundColor: backgroundColor }}>
        <div className="listItem-Label" style={{ color: fontColor }}>
          {label}
        </div>
      </div>
    </div>
  );
};

export default ListItemTag;
